import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/default.jpg';
import _imports_1 from '../assets/drawing.jpg';
import _imports_2 from '../assets/title.png';
import _imports_3 from '../assets/EVA-Home.jpg';
const _withScopeId = (n) => (_pushScopeId("data-v-6209ff91"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "scroll_cont" }, null, -1));
const _hoisted_2 = { class: "containerBase" };
const _hoisted_3 = { class: "cover container4" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "img4",
    alt: "default",
    src: _imports_0
}, null, -1));
const _hoisted_5 = /*#__PURE__*/ _createStaticVNode("<div class=\"cover container3\" data-v-6209ff91><div class=\"drawing\" data-v-6209ff91><img alt=\"drawing\" src=\"" + _imports_1 + "\" data-v-6209ff91></div><img alt=\"title\" src=\"" + _imports_2 + "\" data-v-6209ff91></div><div class=\"cover container1\" data-v-6209ff91><img alt=\"background\" src=\"" + _imports_3 + "\" data-v-6209ff91><div class=\"scroll\" data-v-6209ff91>[scroll to enter]</div></div>", 2);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MenuHome = _resolveComponent("MenuHome");
    const _component_PostSlider = _resolveComponent("PostSlider");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_MenuHome, {
                    pages: _ctx.pages,
                    class: "menu"
                }, null, 8, ["pages"]),
                _createVNode(_component_PostSlider, { class: "subcont" })
            ]),
            _hoisted_5
        ])
    ], 64));
}
